import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - Scrolls to top on route changes, but SKIPS when navigating with a hash.
 * Uses useLayoutEffect to scroll BEFORE paint (prevents flash).
 * 
 * This prevents the "hero flash" issue where hash navigation briefly shows the top of the page.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // If there's a hash, let HashScrollManager handle it - don't scroll to top
    if (hash) {
      return;
    }

    // For route changes without hash, scroll to top instantly (no smooth - prevents flash)
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
